var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgStateSyncingSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 104,
    viewBox: "0 0 120 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.8999 37.9001H12.8999V88.8001H94.8999V37.9001Z",
    fill: "#CAD1E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M94.8999 37.9001H12.8999V88.8001H94.8999V37.9001Z",
    fill: "url(#paint0_linear_0_1826)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.7 34.9001H6.8999V40.2001H100.7V34.9001Z",
    fill: "#D4DAE8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.8999 35.6L54.0999 1L106.2 35.6H1.8999Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9 30.1H17.2L54.1 5.80005L90.9 30.1Z",
    fill: "#BCC5D6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4 30.1H19.7L54.1 7.30005L88.4 30.1Z",
    fill: "#D4DAE8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4999 43.6001H10.2V47.7001H23.4999V43.6001Z",
    fill: "#D4DAE8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1999 83.5H8.3999V87.5H25.1999V83.5Z",
    fill: "#EAEEF9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4999 80.3H10.2V83.6001H23.4999V80.3Z",
    fill: "#D4DAE8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22 47.4001H12V80.2001H22V47.4001Z",
    fill: "#D4DAE8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8 43.6001H29.5V47.7001H42.8V43.6001Z",
    fill: "#D4DAE8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4999 83.5H27.7V87.5H44.4999V83.5Z",
    fill: "#EAEEF9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8 80.3H29.5V83.6001H42.8V80.3Z",
    fill: "#D4DAE8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2998 47.4001H31.2998V80.2001H41.2998V47.4001Z",
    fill: "#D4DAE8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9001 43.6001H65.6001V47.7001H78.9001V43.6001Z",
    fill: "#D4DAE8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5999 83.5H63.7998V87.5H80.5999V83.5Z",
    fill: "#EAEEF9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9001 80.3H65.6001V83.6001H78.9001V80.3Z",
    fill: "#D4DAE8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1001 47.4001H67.1001V80.2001H77.1001V47.4001Z",
    fill: "#D4DAE8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1999 43.6001H84.8999V47.7001H98.1999V43.6001Z",
    fill: "#D4DAE8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9999 83.5H83.2V87.5H99.9999V83.5Z",
    fill: "#EAEEF9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1999 80.3H84.8999V83.6001H98.1999V80.3Z",
    fill: "#D4DAE8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7 47.4001H86.7V80.2001H96.7V47.4001Z",
    fill: "#D4DAE8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M62.2998 57.2002H46.2998V87.5002H62.2998V57.2002Z",
    fill: "#1C3754"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M62.2998 57.2002H46.2998V87.5002H62.2998V57.2002Z",
    fill: "url(#paint1_linear_0_1826)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1001 20.1001C61.1001 20.4001 61.1001 20.4001 61.1001 20.6001V20.9001C60.8001 24.2001 57.8001 26.7001 54.6001 26.7001C51.1001 26.7001 48.3001 24.2001 48.1001 20.9001V20.6001C48.1001 20.3001 48.1001 20.3001 48.1001 20.1001C48.1001 16.6001 51.1001 13.6001 54.6001 13.6001C58.1001 13.6001 61.1001 16.6001 61.1001 20.1001Z",
    fill: "#9CA1B4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1001 20.6C60.8001 24.1 57.8001 26.6 54.6001 26.6C51.1001 26.6 48.3001 24.1 48.1001 20.8V20.6C48.4001 17.3 51.4001 14.8 54.6001 14.8C57.8001 14.8 60.6001 17.3 61.1001 20.6Z",
    fill: "#AFB5C6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M103.2 87.5H4.6001V91.3H103.2V87.5Z",
    fill: "#D4DAE8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M106.7 91.3H0.899902V95.1001H106.7V91.3Z",
    fill: "#EAEEF9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1999 40.2002H8.3999V44.2002H25.1999V40.2002Z",
    fill: "#EAEEF9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4999 40.2002H27.7V44.2002H44.4999V40.2002Z",
    fill: "#EAEEF9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5999 40.2002H63.7998V44.2002H80.5999V40.2002Z",
    fill: "#EAEEF9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9999 40.2002H83.2V44.2002H99.9999V40.2002Z",
    fill: "#EAEEF9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6999 51.3V47.7H98.1999V44.2H99.9999V40.2H100.7V35.6H106.2L54.0999 1L1.8999 35.6H6.8999V40.2H8.3999V44.2H10.1999V47.7H11.8999V80.3H10.1999V83.5H8.3999V87.5H4.69989V91.3H0.899902V95.1H80.1999",
    stroke: "#182052",
    strokeWidth: 0.9773,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 29.9001H75",
    stroke: "#182052",
    strokeWidth: 0.9773,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2998 16.8L54.0999 5.80005",
    stroke: "#182052",
    strokeWidth: 0.9773,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2998 47.6001V74.4001",
    stroke: "#182052",
    strokeWidth: 0.9773,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7 40.3V44.1H29.6V47.8H31.1V52.7",
    stroke: "#182052",
    strokeWidth: 0.9773,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1001 72.5C31.1001 72.8 31.1001 73 31.1001 73.3V80.3",
    stroke: "#182052",
    strokeWidth: 0.9773,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3999 83.5001V80.3H41.1999",
    stroke: "#182052",
    strokeWidth: 0.9773,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7 87.5001V83.3H44.4",
    stroke: "#182052",
    strokeWidth: 0.9773,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7998 91.3H59.2998",
    stroke: "#182052",
    strokeWidth: 0.9773,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 87.5H50.5",
    stroke: "#182052",
    strokeWidth: 0.9773,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2 83.5H23.9999",
    stroke: "#182052",
    strokeWidth: 0.9773,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2999 87.0002C46.2999 86.8002 46.3 86.7002 46.2 86.5002V57.2002H62.2999V80.5002",
    stroke: "#182052",
    strokeWidth: 0.9773,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9999 87.4001C75.6999 87.4001 75.5 87.5001 75.2 87.5001H63.7C63.7 87.4001 63.7 87.4001 63.7 87.3001V83.8001H65.9999C65.9999 83.7001 66 83.6001 65.9 83.5001V80.9001",
    stroke: "#182052",
    strokeWidth: 0.9773,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7998 83.7002H75.1998",
    stroke: "#182052",
    strokeWidth: 0.9773,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2 48.1001C67.2 48.2001 67.2 48.3001 67.2 48.5001V74.6001",
    stroke: "#182052",
    strokeWidth: 0.9773,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 40.2002H76.7",
    stroke: "#182052",
    strokeWidth: 0.9773,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7998 35.7002H62.7998",
    stroke: "#182052",
    strokeWidth: 0.9773,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7 35.8H100.7",
    stroke: "#182052",
    strokeWidth: 0.9773,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7998 40.2002C86.8998 40.2002 86.9999 40.2002 87.0999 40.2002H100.7",
    stroke: "#182052",
    strokeWidth: 0.9773,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1001 44.1001C84.4001 44.1001 84.6001 44.2001 84.6001 45.5001C84.6001 46.3001 84.6001 47.1001 84.6001 47.9001H86.6001V60.4001",
    stroke: "#182052",
    strokeWidth: 0.9773,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3999 44.2002H98.2999",
    stroke: "#182052",
    strokeWidth: 0.9773,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6001 44.1001H80.4001",
    stroke: "#182052",
    strokeWidth: 0.9773,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2 48.4001C77.2 48.7001 77.2 49.0001 77.2 49.4001V59.9002",
    stroke: "#182052",
    strokeWidth: 0.9773,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M118.9 66.663V88.063C118.9 89.963 117.9 91.863 116.1 92.763L99.5999 102.363C98.5999 102.963 97.4999 103.163 96.3999 103.163V76.363L118.2 63.863C118.7 64.763 118.9 65.663 118.9 66.663Z",
    fill: "#36C65F"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4999 76.3629V93.3629V103.263C95.3999 103.263 94.2999 102.963 93.2999 102.463L86.0999 98.2629L76.6999 92.8629C74.9999 91.8629 74.0999 90.0629 73.8999 88.2629V66.5629C73.8999 65.5629 74.1999 64.6629 74.5999 63.7629L96.4999 76.3629Z",
    fill: "#7AE9A0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M118.1 63.863L96.3 76.363L74.5 63.663C74.9 62.863 75.6 62.163 76.4 61.663L93.3 51.763C95 50.763 96.9 50.763 98.6 51.663L116.1 61.863C116.1 61.863 116.2 61.863 116.2 61.963C117.1 62.663 117.7 63.163 118.1 63.863Z",
    fill: "#5BE1A1"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M118.2 63.963L106.2 70.863C106.2 70.763 118.1 63.863 118.2 63.963ZM118.2 63.963C118.2 63.863 117.5 63.063 117.4 63.063C116.7 62.363 115.8 61.763 114.9 61.263C114 60.763 113.1 60.163 112.2 59.663C110.3 58.563 108.3 57.463 106.4 56.263C104.6 55.263 102.8 54.163 101.1 53.163C100.3 52.763 99.6 52.263 98.8 51.863C97.1 51.063 95.2 51.063 93.5 51.963L76.6 61.863C75.8 62.263 75.1 62.963 74.7 63.863C74.3 64.663 74 65.663 74 66.663V88.363C74.1 90.163 75.1 91.963 76.8 92.963L86.2 98.363L93.4 102.563C94.4 103.163 95.5 103.363 96.6 103.363C97.7 103.363 98.8 103.063 99.8 102.563L116.3 92.963C118.1 91.963 119.1 90.163 119.1 88.263C119.1 87.363 119.1 86.463 119.1 85.563C119.1 83.463 119.1 81.463 119.1 79.363C119.1 77.063 119.1 74.763 119.1 72.463C119.1 70.863 119.1 69.263 119.1 67.563C118.9 66.263 118.7 65.063 118.2 63.963Z",
    stroke: "#182052",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M106.5 79.363C106.5 79.463 106.5 79.663 106.4 79.763C106.3 80.163 106.1 80.563 106 81.063C106 81.063 106 81.063 106 81.163C104.6 84.463 101.7 86.863 98.1998 87.563H98.0998C96.8998 87.863 95.5998 87.663 94.3998 87.563C88.6998 86.263 85.1998 80.863 86.3998 75.363C87.4998 69.663 93.0998 66.063 98.5998 67.263C100.5 67.663 102.3 68.663 103.9 70.063C106.2 72.363 107.3 75.963 106.5 79.363Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0998 81.163C94.7998 81.163 94.3998 81.063 94.0998 80.763L91.4998 78.063C90.8998 77.463 90.8998 76.763 91.4998 76.263C92.0998 75.663 92.6999 75.663 93.2999 76.263L94.9998 77.963L99.2999 73.663C99.8999 73.063 100.5 73.063 101.1 73.663C101.7 74.263 101.7 74.963 101.1 75.463L96.0998 80.863C95.7998 80.963 95.4998 81.163 95.0998 81.163Z",
    fill: "url(#paint2_linear_0_1826)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1826",
    x1: 53.9402,
    y1: 81.9723,
    x2: 53.9402,
    y2: 34.8224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1826",
    x1: 54.3161,
    y1: 84.6324,
    x2: 54.3161,
    y2: 56.6524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1826",
    x1: 99.3207,
    y1: 78.9011,
    x2: 94.7707,
    y2: 74.3612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51DFD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BE068"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgStateSyncingSuccess);
export default __webpack_public_path__ + "static/media/img_state_syncing_success.5c4d61359bf50d167154f3426c39c88d.svg";
export { ForwardRef as ReactComponent };